import { StyledSvg } from "baseui/icon";
import React from "react";

export const RemixShopifyIcon = (props: React.ComponentProps<typeof StyledSvg>) => {
  return (
    <StyledSvg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z"
        fill="#F8FFF0"
      />
      <path
        d="M4.34753 16.6V14.5504H8.07868C8.70191 14.5504 8.83723 15.0126 8.83723 15.2881V16.6H4.34753ZM15.3134 13.5795C15.4322 15.1046 15.4322 15.8196 15.4322 16.6H11.9034C11.9034 16.4299 11.9065 16.2745 11.9096 16.1167C11.9191 15.6268 11.9292 15.1157 11.8498 14.0834C11.7446 12.5722 11.0941 12.2364 9.89734 12.2364H4.34753V9.48672H10.0654C11.5768 9.48672 12.3325 9.0269 12.3325 7.80956C12.3325 6.73914 11.5768 6.09065 10.0654 6.09065H4.34753V3.40002H10.6951C14.1169 3.40002 15.8173 5.0161 15.8173 7.59769C15.8173 9.52873 14.6208 10.7881 13.0042 10.9979C14.3687 11.2708 15.1665 12.0474 15.3134 13.5795Z"
        fill="#558B2F"
      />
    </StyledSvg>
  );
};
